const Copyright = () => {
  return <small>&copy;{new Date().getFullYear()} All Rights Reserved</small>;
};

export { Copyright };
